/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import DatePickerBase from './DatePickerBase';

class DatePicker extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override DateInputBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <DatePicker> */
    className: PropTypes.string,
  };

  static defaultProps = {
    styleType: 'default',
    hasError: false,
    disableUnderline: true,
    showPassword: false,
  };

  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <DatePickerBase styles={styles} {...otherProps} />;
  }
}

export default DatePicker;
